import { render, staticRenderFns } from "./RefundItem.vue?vue&type=template&id=2748a862&scoped=true"
import script from "./RefundItem.vue?vue&type=script&lang=js"
export * from "./RefundItem.vue?vue&type=script&lang=js"
import style0 from "./RefundItem.vue?vue&type=style&index=0&id=2748a862&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2748a862",
  null
  
)

export default component.exports